import { useState, type KeyboardEvent } from 'react';

/** Caps Lock state while typing in a field: spread `handlers` on a password input and show a warning while `on`.
 * Browsers only report it on key events, so it is unknown (false) until the first key. */
export function useCapsLock() {
  const [on, setOn] = useState(false);
  const check = (e: KeyboardEvent<HTMLInputElement>) => {
    if (typeof e.getModifierState === 'function') setOn(e.getModifierState('CapsLock'));
  };
  return { on, handlers: { onKeyDown: check, onKeyUp: check, onBlur: () => setOn(false) } };
}
